import { createAction } from '@reduxjs/toolkit';

import { AddUniversityPayload } from './types';

export const setUniversity = createAction<AddUniversityPayload>('universities/set');
export const updateUniversity = createAction<AddUniversityPayload>('universities/update');
